import IdListDTO from './IdListDTO';
import ResourceLinkDTO from './resourceLinkDTO';

export class UserReadConfirmationDTO {
  userId?: string;

  linkId?: number;

  version?: string;

  created?: string;

  requestedVersion?: string;

  readConfirmed?: string;

  lastReminder?: string;

  link?: ResourceLinkDTO;

  audienceIds?: IdListDTO;
}

export class UserReadConfirmationReportDTO {
  audienceIds: number[];

  linkId?: number;

  userId?: string;

  userReadConfirmations?: UserReadConfirmationDTO[];

  constructor() {
    this.audienceIds = [];
  }
}
